import { render, staticRenderFns } from "./GlobalMessenger.vue?vue&type=template&id=1c787be6&scoped=true&"
import script from "./GlobalMessenger.vue?vue&type=script&lang=js&"
export * from "./GlobalMessenger.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMessenger.vue?vue&type=style&index=0&id=1c787be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c787be6",
  null
  
)

export default component.exports